// Give us an ~almost~ unique key prefix for storing data in localForage.
// Why do we need a unique key prefix? Because if you're reverse proxying then you have the same URL
// so IndexedDB gets shared between multiple instances! This uses the project's creation timestamp and id
// to create the key, meaning that two projects must be created in the exact same position at the exact same
// millisecond in two different instances and then accessed by someone using a reverse proxy
// in order to produce the auto-saved transforms loading from one project into another
// TODO create an instance-unique identifier so there is a 0% chance of collisions
export const localForageKeyPrefix = (projectId: number, projectTimestamp: number) =>
  `project{${projectId}}.timestamp{${projectTimestamp}}:`;
